<template>
  <div class="_2">
    <div class="insunet_fc">
      <span>
        <span class="insunet_fc_span">INSUNET</span>
        <span class="insunet_fc_span2">FC</span>
      </span>
    </div>
    <div class="benefit">BENEFIT</div>
    <div class="text">
      <span>
        <span class="text_span">인슈넷FC는 1985년부터 시작한 </span>
        <span class="text_span2">국내 최대 보험대리점</span>
        <span class="text_span3">
          으로
          <br />
        </span>
        <span class="text_span4">안정성이 높은</span>
        <span class="text_span5">
          기업입니다.
          <br />
          항상 고객의 입장에서 유리한 보험사를 선택하도록 제안하며
          <br />
        </span>
        <span class="text_span6">24시간 365일</span>
        <span class="text_span7">
          고객을 보호하기 위해 노력합니다.
          <br />
        </span>
        <span class="text_span8">12개 보험사의 자동차보험</span>
        <span class="text_span9">
          을 전문적으로 비교하여
          <br />
        </span>
        <span class="text_span10">최저 보험료</span>
        <span class="text_span11">
          를 선택할 수 있도록 도와드립니다.
        </span>
      </span>
    </div>
    <a class="div" @click="handleClick">상담 신청</a>
    <img class="vector_5" />
    <div class="rectangle-34"></div>
    <img class="pic_1" src="/static/salesReservation/Rectangle_37.png" />
    <img class="pic_2" src="/static/salesReservation/Rectangle_36.png" />
    <div class="div2">고객 보호 및 보험료 절약</div>
    <div class="div3">통합적 보험설계 서비스</div>
  </div>
</template>
<script>
export default {
  name: 'ConsultationCard',
  props: {
    refin: {
      type: String,
      default: ''
    },
    sorce: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick() {
      console.log('상담 신청 버튼이 클릭되었습니다.');
      console.log('refin:', this.refin);
      console.log('sorce:', this.sorce);

      this.$router.push({
        path: '/sales/reservationd',
        query: {
          refin: this.refin,
          sorce: this.sorce
        }
      });
    }
  }
}
</script>
    
<style scoped>
@import url("https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/variable/pretendardvariable.min.css");

body, ._2, .insunet_fc, .benefit, .text, .div, .div2, .div3 {
  font-family: 'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif;
}

._2,
._2 * {
  box-sizing: border-box;
}

._2 {
  background: #ffffff;
  width: 100vw;
  height: 100vh;
  position: relative;
  overflow: hidden;
}

.insunet_fc {
  color: rgba(0, 0, 0, 0.05);
  text-align: left;
  font-size: clamp(90px, 15vw, 180px);
  letter-spacing: 0;
  font-weight: 900; /* Black */
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  width: 100%;
  text-align: center; 
  white-space: nowrap; 
}

.insunet_fc_span, .insunet_fc_span2 {
  color: rgba(0, 0, 0, 0.05);
  font-weight: 900; 
  display: inline-block;
}

.insunet_fc_span {
  letter-spacing: 0.08em;
}

.insunet_fc_span2 {
  letter-spacing: 0.05em;
}

.benefit {
  color: #000000;
  text-align: left;
  font-size: clamp(30px, 5vw, 50px);
  letter-spacing: 0.03em;
  font-weight: 800; /* ExtraBold */
  position: absolute;
  left: 10%;
  top: 15%;
}

.text {
  color: #000000;
  text-align: left;
  font-size: clamp(14px, 2vw, 20px);
  line-height: 160%;
  letter-spacing: 0.03em;
  font-weight: 400;
  position: absolute;
  left: 10%;
  top: 30%;
  max-width: 50%;
}

.text_span, .text_span3, .text_span5, .text_span7, .text_span9, .text_span11 {
  font-weight: 500; /* Medium */
}

.text_span2, .text_span4, .text_span6, .text_span8, .text_span10 {
  font-weight: 600; /* SemiBold */
}

._2 .div {
  color: #184de5;
  text-align: left;
  font-size: clamp(18px, 2.5vw, 24px);
  font-weight: 700; /* Bold */
  position: absolute;
  left: 10%;
  top: 60%;
  cursor: pointer;
}

._2 .vector_5 {
  width: clamp(60px, 8vw, 89px);
  height: 2px;
  background-color: #184de5;
  position: absolute;
  left: 10%;
  top: calc(60% + 30px);
}

.rectangle-34 {
  background: rgba(255, 0, 0, 0.8);
  width: 10px;
  height: 10px;
  position: absolute;
  left: calc(10% + clamp(60px, 8vw, 89px));
  top: calc(60% - 10px);
}

._2 .pic_1, 
._2 .pic_2 {
  width: 15%;
  height: auto;
  position: absolute;
  object-fit: cover;
}

.pic_1 {
  right: 25%;
  bottom: 35%;
}

.pic_2 {
  right: 5%;
  top: 25%;
}

._2 .div2, 
._2 .div3 {
  color: var(--grays-gray-6, #f2f2f7);
  text-align: left;
  font-size: clamp(12px, 1.5vw, 14px);
  font-weight: 700; /* Bold */
  position: absolute;
}

.div2 {
  right: 7%;
  bottom: 47%;
}

.div3 {
  right: 28%;
  bottom: 36%;
}

/* @media (max-width: 768px) {
  .text {
    max-width: 80%;
  }

  .pic_1, .pic_2 {
    width: 10%;
  }

  .pic_2 {
    right: 10%;
    top: 40%;
  }

  .div2 {
    right: 12%;
    bottom: 45%;
  }
} */
</style>